import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import Button from "../Button";
import Callout from "../Callout";

function SignParentConsentForm() {
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const { code } = useParams();

  const [pdfUrl, setPdfUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [signature, setSignature] = useState("");
  const [editedPdfUrl, setEditedPdfUrl] = useState("");
  const [originalBlob, setOriginalBlob] = useState(null);



  useEffect(() => {
    const fetchPDF = async () => {
      try {
        const response = await axios.get(`${API_ENDPOINT}/api/sign-parent-form/${code}/`);
        const fullUrl = `${API_ENDPOINT}${response.data.pdf}`;
        
        // Use axios instead of fetch to avoid CORS issues
        const blobResponse = await axios.get(fullUrl, {
          responseType: 'blob',
          headers: {
            'Accept': 'application/pdf',
          }
        });
        
        const blob = blobResponse.data;
        const blobUrl = URL.createObjectURL(blob);
        setPdfUrl(blobUrl);
        setOriginalBlob(blob);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching parent form:", err);
        setLoading(false);
      }
    };

    fetchPDF();
  }, [API_ENDPOINT, code]);


  if (loading) return <p>Loading the Parent Consent Form...</p>;

  return (
    <div style={{ padding: "40px", maxWidth: "1000px", margin: "0 auto", textAlign: "left" }}>
      {/* <Callout text="Please review the consent form below. This form allows your child to take college-level courses while in high school. By signing this document, you confirm your understanding and permission for your child to participate in dual enrollment." /> */}

      {!editedPdfUrl && (
        <div style={{ marginTop: "20px" }}>
          <iframe
            src={pdfUrl}
            width="100%"
            height="1000px"
            title="PDF Preview"
            style={{ border: "1px solid #ccc" }}
          />
        </div>
      )}

    </div>
  );
}

export default SignParentConsentForm;